module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('b', [_vm._v("Acknowledgements")])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he author acknowledges the assistance of several individuals and organizations during the compilation of this book. At an organizational level these include in particular the Royal Arsenal Woolwich Historical Society, the Crossness Engines Trust, the National Archives, the London Metropolitan Library, the Railway Correspondence and Travel Society, the Stephenson Locomotive Society, the Greenwich Heritage Centre, the Industrial Railway Society, Chasewater Railway Museum and the Narrow Gauge Railway Society.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Individuals whose contributions deserve commendation include Robin Parkinson and Ian Bull for their valuable assistance with detailed research at the compilation stage, particularly in relation to information concerning the compressed air and internal combustion locomotives; Mike Swift for his loan of research carried out at the Arsenal during the 1960s and 1970s; Ray Fordham, John Alsop, Mike Christensen and David Ronald for their assistance in the sourcing of photographs; Robin Waywell for his help in the provision of information concerning the acquisition and disposal of locomotives and rolling stock; Dawn Whitehead and Anthony Coulls of the National Railway Museum; John Batts; Ray Hooley (Ruston Diesels Archivist); Mike Fell; Tony Hill; Phillip Clarke; the late Ron Redman; Russell Wear; Michael Bradley of the Historical Model Railway Society; Graham Lee, Henry Noon and Hazel Tomlinson of the Hunslet Archive at Statfold Barn: Allan Baker; Jim Greaves, John Tisdale, Don Townsley and Paul Coutanche.")])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5180a0bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Acknowledgements.vue
// module id = 69
// module chunks = 0